<template>
    <div class="principal">
        <NavBar :usarAberto="false" :usarHistorico="false" :usarVoltar="true" :usarDeslogar="false" :usarGerenciar="false"
            :usarRelatorio="false" :usarFiltros="true" :usarFiltroSetor="true" :usarFiltroTpChamado="true"
            :usarFiltroPosicao="true" :usarFiltroDatas="true" :usarTrocaVisualizacao="true"
            :formatarDataInicioMes="formatarDataInicioMes" :card="true" :tabela="true" :grafico="false"
            :visualizacaoPadrao="'Card'" :nomeTela="'Histórico Geral'" @filtrar="filtrar()" />

        <div class="displayflex flex-wrap jContent gap-3 mb-1" v-show="(erro == null) && (card === 'Card')">
            <Card v-for="dChamado in dadosChamados" :key="dChamado.id" :dChamado="dChamado" :tpChamado="tipoChamado" />
        </div>
        <div v-show="(erro == null) && (card === 'Tabela')">
            <Grid :dChamado="dadosChamados" :tpChamado="tipoChamado" />
        </div>

        <Modal :mostrar="erro != null" @fechar="fechar()" :usarCronometro="true">
            <template v-slot:header>
                <p class="erro"> {{ erro }} </p>
            </template>
            <template v-slot:corpo>
                Parece que existe um problema de conexão, por favor tente outra vez mais tarde
            </template>
        </Modal>
    </div>
</template>

<script>
import Chamado from '@/model/Chamado';
import Leito from '@/model/Leito';
import Quarto from '@/model/Quarto';
import Setor from '@/model/Setor';
import api from "@/api/api";
import TipoChamado from '@/model/TipoChamado';
import Card from '@/components/Card.vue';
import store from '@/store/store';
import Modal from '@/components/Modal.vue';
import _versao from '@/../package.json';
import NavBar from '@/components/NavBar.vue';
import moment from 'moment';
import Grid from '@/components/Grid.vue';

export default {
    name: 'secundariA',

    props: ['formatarDataInicioMes'],

    components: {
        Card,
        Modal,
        NavBar,
        Grid
    },

    data() {
        return {
            dadosChamados: [],
            valorFiltroPosicao: 'FE',
            valorFiltroTPChamado: 0,
            valorFiltroQuarto: 0,
            valorFiltroLeito: 0,
            valorFiltroSetor: 0,
            valorOrderData: 'desc',
            valorOrderHora: 'desc',
            dataSql: String(),

            erro: null,
            card: "Card",
            versao: _versao.version
        };
    },

    mounted() {
        return [
            this.carregarChamados(0, 0, 0, "FE", this.formatarDataInicioMes(new Date()), new Date(), "Card")
        ];
    },

    methods: {
        async carregarChamados(aux, pValorFiltroSetor, pValorFiltroTPChamado, pValorFiltroPosicao, pDataInicial, pDataFinal, pValorVisualizacao) {
            if (pValorVisualizacao != this.card) {
                this.card = pValorVisualizacao;
            } else {
                let pData = '';
                if (pDataInicial != null && pDataFinal != null) {
                    let pDataTemp1 = moment(pDataInicial).format("MM/DD/YYYY");
                    let pDataTemp2 = moment(pDataFinal).format("MM/DD/YYYY");
                    pData = "'" + pDataTemp1 + "' and '" + pDataTemp2 + "'";
                    this.dataSql = pData;
                }
                await api.filtrarDados(pValorFiltroPosicao, pValorFiltroTPChamado, pValorFiltroSetor,
                    this.valorFiltroQuarto, this.valorFiltroLeito, this.valorOrderData, this.valorOrderHora, pData)
                    .then(resposta => {
                        //Bubble Sort
                        let aux = [];
                        aux = resposta;
                        for (let i = 0; i < aux.length; i++) {
                            for (let j = 0; j < (aux.length - i - 1); j++) {
                                if (aux[j].id < aux[j + 1].id) {
                                    let temp = aux[j];
                                    aux[j] = aux[j + 1];
                                    aux[j + 1] = temp;
                                }
                            }
                        }
                        this.dadosChamados = aux;
                    })
                    .catch(error => {
                        this.erro = error;
                    });
            }
        },

        async filtrar(aux, pValorFiltroSetor, pValorFiltroTPChamado, pValorFiltroPosicao, pDataInicial, pDataFinal, pVisualizacao) {
            this.valorFiltroSetor = pValorFiltroSetor;
            this.valorFiltroTPChamado = pValorFiltroTPChamado;
            this.valorFiltroPosicao = pValorFiltroPosicao;
            this.carregarChamados(aux, pValorFiltroSetor, pValorFiltroTPChamado, pValorFiltroPosicao, pDataInicial, pDataFinal, pVisualizacao);
        },

        async filtrarGrid() {
            await api.filtrarDados(this.valorFiltroPosicao, this.valorFiltroTPChamado, this.valorFiltroSetor,
                this.valorFiltroQuarto, this.valorFiltroLeito, this.valorOrderData, this.valorOrderHora, this.dataSql)
                .then(resposta => {
                    //Bubble Sort
                    let aux = [];
                    aux = resposta;
                    for (let i = 0; i < aux.length; i++) {
                        for (let j = 0; j < (aux.length - i - 1); j++) {
                            if (aux[j].id < aux[j + 1].id) {
                                let temp = aux[j];
                                aux[j] = aux[j + 1];
                                aux[j + 1] = temp;
                            }
                        }
                    }
                    this.dadosChamados = aux;
                });
        },

        excluir(id) {
            this.dadosChamados = this.dadosChamados.filter(ch => ch.id != id);
        },

        adicionar(pChamado) {
            if (pChamado.posicao != "AB") {
                this.dadosChamados.push(
                    new Chamado(
                        pChamado.id,
                        pChamado.data,
                        pChamado.hora,
                        new Leito(pChamado.leito.id, pChamado.leito.codigoLeito, pChamado.leito.descricao, pChamado.leito.ativo,
                            new Quarto(pChamado.leito.quarto.id, pChamado.leito.quarto.codigoQuarto, pChamado.leito.quarto.descricao, pChamado.leito.quarto.ativo,
                                new Setor(pChamado.leito.quarto.setor.id, pChamado.leito.quarto.setor.ativo, pChamado.leito.quarto.setor.codigoSetor, pChamado.leito.quarto.setor.descricao)
                            )
                        ),
                        new TipoChamado(pChamado.tipoChamado.id, pChamado.tipoChamado.descricao, pChamado.tipoChamado.ativo, pChamado.tipoChamado.cor, pChamado.tipoChamado.som, pChamado.tipoChamado.fonte, pChamado.tipoChamado.borda, pChamado.tipoChamado.corIcone, pChamado.tipoChamado.urgencia, pChamado.tipoChamado.id_Principal),
                        pChamado.posicao,
                        pChamado.dtFinalizacao,
                        pChamado.hrFinalizacao,
                        pChamado.dtCancelamento,
                        pChamado.hrCancelamento,
                        pChamado.motivo
                    )
                );
            }
        },

        fechar() {
            if (this.filtrar) {
                this.erro = null;
            }
        },

        deslogar() {
            sessionStorage.removeItem("TokenReguaPainel");
            this.$router.back();
        },
    },

    computed: {
        setores() {
            return store.state.setores;
        },
        config() {
            return store.state.config;
        },
        tipoChamado() {
            return store.state.tipoChamado;
        },
        token() {
            return (sessionStorage.TokenReguaPainel) ? true : false;
        },
    }
};

</script>

<style scoped>
p {
    margin-bottom: 0;
    margin-top: 7px;
}

.displayflex {
    display: flex;
}
</style>